<template>
  <div class="table-body">
    <div style="height: 20px;background:#fff;"></div>
    <el-table
      :data="tableData"
      border
      :maxHeight="maxHeight"
      :class="tableBorderStyle[borderStyle]"
    >
      <el-table-column type="index" width="60" label="序号"></el-table-column>
      <template v-for="(item, index) in tableColumn">
        <el-table-column v-if="item.render" v-bind="item" :key="index">
          <Render
            :render="item.render"
            :rows="scope"
            slot-scope="scope"
          ></Render>
        </el-table-column>
        <el-table-column
          v-else
          v-bind="item"
          :key="index"
          :show-overflow-tooltip="true"
        >
          <template v-if="item.children">
            <el-table-column
              v-for="(itemChildren, itemChildrenIndex) in item.children"
              :key="itemChildrenIndex"
              v-bind="itemChildren"
              :show-overflow-tooltip="true"
            >
            </el-table-column>
          </template>
        </el-table-column>
      </template>
    </el-table>
  </div>
</template>

<script>
/**
 *   详情展示中的table表格
 *
 */
export default {
  name: "detail-info-table",
  components: {
    // 自定义render方法,可通过jsx或render函数自定义表格项
    Render: {
      functional: true,
      props: {
        render: Function,
        rows: Object
      },
      render: (h, ctx) => {
        return ctx.props.render(h, ctx.props.rows.row);
      }
    }
  },
  props: {
    // 表格数据
    tableData: {
      type: Array,
      default() {
        return [];
      }
    },
    // 表格项
    tableColumn: {
      type: Array,
      default() {
        return [];
      }
    },
    // 表格高度
    maxHeight: {
      type: [String, Number]
    },
    borderStyle: {
      type: Number,
      default: 1
    }
  },
  data() {
    return {
      tableBorderStyle: {
        1: "",
        2: "table-body-round-line"
      }
    };
  }
};
</script>

<style lang="scss" scoped>
@import "~@/styles/variables";
.table-body {
  /deep/ .el-table {
    thead {
      color: #4a4a4a;
      th {
        font-weight: 500;
      }
    }
    .el-table__body-wrapper .el-table__body tr td .cell {
      padding: 0 10px;
    }
    &.table-body-round-line {
      thead {
        th:not(:nth-last-child(2)) {
          border-right: none;
        }
      }
      tbody {
        td:not(:last-child) {
          border-right: none;
        }
      }
    }
  }
}
</style>
